import {useMutation, useQueries, useQueryClient} from 'react-query';
import {deleteQrCode, getQRCode, updateQRCode} from './orderQRCode';
import {IPatchQrCodeBody} from './orderQrCode.types';

export function useGetQRCodes({
  advertisementIdList,
}: {
  advertisementIdList: string[];
}) {
  const queries = useQueries(
    advertisementIdList.map(advertisementId => ({
      queryKey: ['qr-code', advertisementId],
      queryFn: () => getQRCode({advertisementId}),
      enabled: !!advertisementId,
    })),
  );
  const mappedData = queries
    .map(query => ({
      data: query.data,
      error: query.error,
    }))
    .filter(item => item !== undefined);
  const isLoading = queries.some(item => item.isLoading);
  const isError = queries.some(item => item.isError);

  return {
    data: mappedData,
    isLoading,
    isError,
  };
}
export function useUpdateQRCodes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: IPatchQrCodeBody) => updateQRCode(data),
    onSuccess: () =>
      queryClient.invalidateQueries({queryKey: ['get-store-order-details']}),
  });
}

export function useDeleteQRCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({advertisementId}: {advertisementId: string}) =>
      deleteQrCode({advertisementId}),
    onSuccess: () =>
      queryClient.invalidateQueries({queryKey: ['get-store-order-details']}),
  });
}
